import { render, staticRenderFns } from "./PainelEletronico.vue?vue&type=template&id=793e773e&scoped=true&"
import script from "./PainelEletronico.vue?vue&type=script&lang=js&"
export * from "./PainelEletronico.vue?vue&type=script&lang=js&"
import style0 from "./PainelEletronico.vue?vue&type=style&index=0&id=793e773e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793e773e",
  null
  
)

export default component.exports